import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: 'mwp-wizard-button-control',
    templateUrl: './wizard-button-control.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WizardButtonControlComponent implements OnInit {
    @Input() public isContinueDisabled: boolean;
    @Input() public hideCancelButton: boolean;
    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();
    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();

    public displayBackButton: boolean;

    constructor(
    ) {
    }

    ngOnInit() {
    }

    public complete(): void {
        this.emitComplete.emit();
    }

    public cancel(): void {
        this.emitCancel.emit();
    }

    public back(): void {
    }
}
